module.exports = __webpack_public_path__ + "img/ic_drawer_2.edaffee0.svg";